(() => {
  if (window.ypcExplorePreviewLoaded) return;
  window.ypcExplorePreviewLoaded = true;
  let dialog;
  let opener;
  let image;
  let title;
  let description;
  let close;
  const supported = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'ypc-explore-preview';
    const panel = document.createElement('div');
    panel.className = 'ypc-explore-preview__panel';
    close = document.createElement('button');
    close.type = 'button';
    close.className = 'ypc-explore-preview__close';
    close.textContent = '×';
    image = document.createElement('img');
    image.className = 'ypc-explore-preview__image';
    title = document.createElement('h2');
    title.className = 'ypc-explore-preview__title';
    description = document.createElement('p');
    description.className = 'ypc-explore-preview__description';
    panel.append(close, image, title, description);
    dialog.append(panel);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ypc-explore-preview-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  }
  function initialize(scope = document) {
    if (!supported) return;
    scope.querySelectorAll('[data-ypc-explore-preview]').forEach((root) => {
      root.querySelectorAll('[data-ypc-pose-preview]').forEach((button) => { button.disabled = false; });
    });
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ypc-pose-preview]');
    if (!button || button.disabled || !supported) return;
    const card = button.closest('.ypc-explore-card');
    const root = button.closest('[data-ypc-explore-preview]');
    const photo = card?.querySelector('.ypc-explore-photo');
    const heading = card?.querySelector('h3');
    if (!root || !photo || !heading) return;
    if (!dialog) createDialog();
    opener = button;
    title.textContent = heading.textContent.trim();
    description.textContent = card.querySelector('.ypc-explore-copy p')?.textContent.trim() || '';
    description.hidden = !description.textContent;
    image.src = photo.getAttribute('src');
    image.alt = title.textContent;
    image.width = Number(photo.getAttribute('width'));
    image.height = Number(photo.getAttribute('height'));
    close.setAttribute('aria-label', root.dataset.closeLabel);
    dialog.setAttribute('aria-label', title.textContent);
    dialog.showModal();
    document.documentElement.classList.add('ypc-explore-preview-open');
    close.focus({ preventScroll: true });
  });
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
